import { render, staticRenderFns } from "./returnInformation.vue?vue&type=template&id=60979b94&scoped=true"
import script from "./returnInformation.vue?vue&type=script&lang=js"
export * from "./returnInformation.vue?vue&type=script&lang=js"
import style0 from "./returnInformation.vue?vue&type=style&index=0&id=60979b94&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60979b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60979b94')) {
      api.createRecord('60979b94', component.options)
    } else {
      api.reload('60979b94', component.options)
    }
    module.hot.accept("./returnInformation.vue?vue&type=template&id=60979b94&scoped=true", function () {
      api.rerender('60979b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/returned/returnInformation.vue"
export default component.exports